<template>
  <div class="registration-layout">
    <registration-header
      :hide-nav="hideNav"
      :steps="steps"
      :step-id="stepId"
      :disable-step-clicks="disableStepClicks"
      @clicked-step-id="(id) => $emit('clicked-step-id', id)"
    />
    <div v-if="revisitName" class="registration-layout__revisit-message">
      Welcome back, <strong>{{revisitName}}!</strong> You've already signed up for DoneDone previously.<br>
      Filling out this form will create a <strong>new</strong> account.
      If this is not intended,  <a :href="RouteAssistant.getLoginUrl()" class="just-a-link">sign-in to your existing account</a>.
    </div>
    <main-container :size="size">
      <el-card class="registration-layout__card">
        <slot />
      </el-card>
    </main-container>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import MainContainer from '@/layouts/main-container.vue'

/* Mixins */

/* Components */
import RegistrationHeader from '@/views/registration-header.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { IItemForSelection } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'RegistrationLayout',

  components: {
    RegistrationHeader,
    MainContainer,
  },

  props: {
    steps: {
      type: Array as () => IItemForSelection[],
      default: (): IItemForSelection[] => [],
    },
    stepId: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: 'small',
    },
    revisitName: {
      type: String,
      default: '',
    },
    disableStepClicks: {
      type: Boolean,
      default: false,
    },
    hideNav: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['clicked-step-id'],

  data() {
    return {
      RouteAssistant,
    }
  },

  mounted() {
    const head = document.head
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src =
      'https://t.donedone.com/v1/lst/universal-script?ph=8255e0cf5770ad2c3da3318cfe3eccb945a0f2012e8e98d7573e02e8bbb71097&tag=!clicked'
    script.src += '&ref_url=' + encodeURI(document.URL)
    head.appendChild(script)
  },
})
</script>

<style lang="scss">
.registration-layout {
  padding-top: $navbar-mobile-height;

  &__revisit-message {
    text-align: center;
    padding: 20px 0;
    background-color: var(--color-background-blue-15);
    @include lettering--p;
  }

  &__card {
    /* Allow timezone dropdown to overflow */
    overflow: visible;

    .el-card__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px;

      .el-form {
        padding-top: 10px;
        width: 100%;
      }

      .dd-button {
        width: 100%;
      }
    }
  }

  @include media-breakpoint-up(md) {
    padding-top: $navbar-desktop-height;
  }
}
</style>
